<template>
    <el-table
        :data="tableData"
        style="width: 100%"
        height="100%"
        border
        class="leader-style-table"
    >
        <el-table-column
            v-for="col in columns"
            :key="col.prop"
            :prop="col.prop"
            :label="col.label"
            align="center"
        ></el-table-column>
    </el-table>
</template>
<script>
export default {
    props: {
        tableData: {
            type: Array
        },
        columns: {
            type: Array,
            required: true
        }
    }
};
</script>
<style lang="scss" scoped></style>
